import { Navigate, Outlet, useLocation } from "react-router-dom";
import { localStorageHelper } from "../utils/local-storage-helper";

const RequireAuth = () => {
   const location = useLocation();

   return localStorageHelper.get("accessToken") ? <Outlet /> : <Navigate to="/login" state={{ from: location }} replace />;
};

export default RequireAuth;
